
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.083.438a1.001 1.001 0 00-1.505 1.32l3.749 4.28-3.75 4.28a1.001 1.001 0 001.506 1.32l4.338-4.94a1 1 0 000-1.32L2.083.438z","fill":"#6E88F3"}})])
          )
        }
      }
    